import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { OverlayRef } from '@angular/cdk/overlay';
import {
  PrivacyStateService,
  SearchSubscriptionService,
} from '@immosky/shared';
import { Store } from '@ngrx/store';
import { AppState, AppParametersService } from '@immosky/types';
import { LayoutService } from '../../services/layout.service';
import { ObjectSearchAppParameters } from '../../services/object-search-app-parameters.service';

export type SearchSubscriptionOverlayOrigin =
  | 'results-overview'
  | 'mobile-filters';

export const SEARCH_SUBSCRIPTION_OVERLAY_ORIGIN =
  'SEARCH_SUBSCRIPTION_OVERLAY_ORIGIN';

@Component({
  selector: 'app-search-subscription-overlay',
  templateUrl: './search-subscription-overlay.component.html',
  styleUrls: ['./search-subscription-overlay.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchSubscriptionOverlayComponent {
  private acceptedRelevantCookies = false;

  wasSuccessful = false;

  get canSubmit(): boolean {
    return (
      this.searchSubscriptionService.isValid && this.acceptedRelevantCookies
    );
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    @Inject(SEARCH_SUBSCRIPTION_OVERLAY_ORIGIN)
    private origin: SearchSubscriptionOverlayOrigin,
    private overlayRef: OverlayRef,
    private searchSubscriptionService: SearchSubscriptionService,
    private appParametersService: AppParametersService<ObjectSearchAppParameters>,
    private layoutService: LayoutService,
    private privacyStateService: PrivacyStateService
  ) {
    this.privacyStateService.canSubmitForm.subscribe(
      (canSubmitForm: boolean) => {
        this.acceptedRelevantCookies = canSubmitForm;
        this.cdRef.markForCheck();
      }
    );
  }

  saveSearchSubscription() {
    this.searchSubscriptionService.submitSearchSubscription(
      this.appParametersService.get().countries[0]
    );
    this.wasSuccessful = true;
  }

  close() {
    this.overlayRef.dispose();
  }

  goToMobileFilters(event: MouseEvent) {
    event.stopPropagation();

    this.layoutService.openMobileFilters();

    if (this.origin !== 'results-overview') {
      this.close();
    }
  }
}
